import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const PrivacyEs = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "es";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          ES
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/privacy">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/privacy">JA</Link>
            </li>
            <li>
              <Link to="/policy/vi/privacy">VI</Link>
            </li>
            <li>
              <Link to="/policy/th/privacy">TH</Link>
            </li>
            <li>
              <Link to="/policy/id/privacy">ID</Link>
            </li>
            <li className="selected">
              <em>ES</em>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>Política de Privacidad de pregnancy&amp;baby</PolicyTitle>

      <PolicyVersion>
        Fecha de entrada en vigor: [21 de septiembre de 2026]
        <br />
        Última actualización: [25 de agosto de 2026]
      </PolicyVersion>
      <PolicyText>
        Connecti Co., Ltd. (en adelante, “Connecti”, la “Empresa”, “nosotros” o
        “nuestro”) respeta la privacidad de los usuarios de{" "}
        <strong>pregnancy&amp;baby</strong> y considera que la protección y el
        tratamiento adecuado y seguro de los Datos Personales constituyen una
        responsabilidad fundamental.
      </PolicyText>
      <PolicyText>
        La presente Política de Privacidad explica qué Datos Personales
        recopilamos, para qué fines los tratamos, en qué circunstancias pueden
        compartirse o transferirse, durante cuánto tiempo los conservamos y qué
        derechos tienen los usuarios en relación con sus Datos Personales.
      </PolicyText>
      <PolicyText>
        Esta Política se aplica a la aplicación móvil{" "}
        <strong>pregnancy&amp;baby</strong>, al sitio web y a los productos,
        funciones y servicios relacionados (en conjunto, los “Servicios”).
      </PolicyText>
      <PolicyText>
        Podremos modificar esta Política de Privacidad cuando sea necesario. Si
        realizamos cambios importantes, informaremos a los usuarios a través de
        los Servicios, por correo electrónico o mediante otros medios adecuados,
        de conformidad con la legislación aplicable. Cuando la ley lo exija,
        solicitaremos nuevamente el consentimiento del usuario.
      </PolicyText>

      <PolicySectionTitle>
        1. Datos Personales que recopilamos
      </PolicySectionTitle>
      <PolicyText>
        Podemos recopilar Datos Personales proporcionados directamente por los
        usuarios, información recopilada automáticamente durante el uso de los
        Servicios y determinada información facilitada por proveedores externos
        de autenticación.
      </PolicyText>

      <PolicyArticleTitle>
        1.1 Información de la cuenta y del perfil
      </PolicyArticleTitle>
      <PolicyText>
        Cuando un usuario crea o utiliza una cuenta, podemos recopilar:
      </PolicyText>
      <PolicyHyphenList>
        <li>Dirección de correo electrónico</li>
        <li>Año de nacimiento</li>
        <li>Nombre de usuario o apodo</li>
        <li>Foto de perfil</li>
        <li>Región o lugar de residencia</li>
        <li>Idioma</li>
        <li>Zona horaria</li>
      </PolicyHyphenList>
      <PolicyText>
        La información concreta recopilada puede variar en función de las
        funciones utilizadas y del método de registro de la cuenta.
      </PolicyText>

      <PolicyArticleTitle>
        1.2 Información de inicio de sesión mediante terceros
      </PolicyArticleTitle>
      <PolicyText>
        Los usuarios pueden crear una cuenta o iniciar sesión mediante:
      </PolicyText>
      <PolicyHyphenList>
        <li>Google</li>
        <li>Apple</li>
      </PolicyHyphenList>
      <PolicyText>
        Cuando se utiliza un servicio de inicio de sesión de terceros, podemos
        recibir del proveedor correspondiente:
      </PolicyText>
      <PolicyHyphenList>
        <li>Identificador de cuenta (ID)</li>
        <li>Nombre o nombre mostrado</li>
      </PolicyHyphenList>
      <PolicyText>
        La información que recibimos puede variar en función del proveedor y de
        la configuración del usuario en dicho servicio.
      </PolicyText>
      <PolicyText>
        El tratamiento realizado por cada proveedor de inicio de sesión se rige
        por su propia política de privacidad.
      </PolicyText>

      <PolicyArticleTitle>
        1.3 Datos relativos a la salud, preparación para el embarazo, embarazo y
        bienestar
      </PolicyArticleTitle>
      <PolicyText>
        Algunas funciones de los Servicios permiten que los usuarios introduzcan
        voluntariamente información relacionada con su salud, la preparación
        para el embarazo, el embarazo y su bienestar.
      </PolicyText>
      <PolicyText>
        En función de las funciones utilizadas, esta información puede incluir:
      </PolicyText>

      <PolicyList>
        <li>
          <strong>Preparación para el embarazo</strong>
          <PolicyHyphenList>
            <li>Duración y ciclo menstrual</li>
            <li>Fecha de la última menstruación</li>
            <li>Fechas de inicio y finalización de la menstruación</li>
            <li>Fecha de ovulación</li>
            <li>Fecha y hora de la prueba de ovulación</li>
            <li>Imágenes y resultados de pruebas de ovulación</li>
            <li>Fecha y hora de la prueba de embarazo</li>
            <li>Imágenes y resultados de pruebas de embarazo</li>
            <li>Temperatura basal</li>
            <li>Síntomas</li>
            <li>Registros de dolor y sangrado</li>
            <li>Registros de medicación</li>
            <li>Registros de vacunación</li>
            <li>Registros de consultas médicas</li>
            <li>Registros de actividad sexual</li>
            <li>Notas y otros datos registrados por la usuaria</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Tratamientos de fertilidad</strong>
          <PolicyHyphenList>
            <li>Tipo de tratamiento de fertilidad</li>
            <li>Ciclo y número de tratamientos</li>
            <li>Fecha de inicio y finalización del tratamiento</li>
            <li>Registros de medicamentos e inyecciones</li>
            <li>Calendario y detalles del tratamiento</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Embarazo</strong>
          <PolicyHyphenList>
            <li>Fecha estimada de parto</li>
            <li>Nombre cariñoso o apodo del bebé durante el embarazo</li>
            <li>Edad gestacional</li>
            <li>Información registrada en el diario del embarazo</li>
            <li>Registros de consultas médicas</li>
            <li>Registros de vacunación</li>
            <li>Registros de peso</li>
            <li>Imágenes de ecografía</li>
            <li>Mediciones fetales, como EFW, AC, FL, BPD, HC y CRL</li>
            <li>Altura y peso antes del embarazo</li>
            <li>Historial de cambios de peso</li>
            <li>
              Otra información relacionada con el embarazo introducida por la
              usuaria
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Cuidado infantil y posparto</strong>
          <br />
          En función de las funciones utilizadas, podemos recopilar la siguiente
          información relativa al niño:
          <PolicyHyphenList>
            <li>Nombre</li>
            <li>Sexo</li>
            <li>Fecha de nacimiento</li>
            <li>Peso al nacer</li>
            <li>Altura al nacer</li>
            <li>Perímetro cefálico al nacer</li>
            <li>Fecha estimada de parto</li>
            <li>Registros de revisiones médicas</li>
            <li>Registros de vacunación</li>
            <li>
              Datos de crecimiento, como altura, peso y perímetro cefálico
            </li>
            <li>Registros y puntuaciones de evaluaciones del desarrollo</li>
            <li>Fotografías relacionadas con el desarrollo</li>
            <li>Información sobre nacimiento prematuro</li>
            <li>Registros de temperatura corporal</li>
            <li>Registros de medicación</li>
            <li>Información sobre enfermedades</li>
          </PolicyHyphenList>
          Para las funciones de control del peso posparto, también podemos
          recopilar:
          <PolicyHyphenList>
            <li>Altura y peso antes del embarazo</li>
            <li>Peso inmediatamente antes del parto</li>
            <li>Registros de peso después del parto</li>
          </PolicyHyphenList>
          Algunos de estos datos, especialmente los{" "}
          <strong>datos relativos a la salud</strong>, pueden constituir{" "}
          <strong>categorías especiales de Datos Personales</strong> conforme al
          Reglamento General de Protección de Datos (RGPD). La AEPD considera
          los datos de salud especialmente protegidos y su tratamiento requiere
          que concurra una de las excepciones previstas en el artículo 9 del
          RGPD, entre ellas el consentimiento explícito del interesado. (
          <a
            href="https://www.aepd.es/areas-de-actuacion/salud/tus-derechos-en-relacion-con-tus-datos-de-salud?utm_source=chatgpt.com"
            target="_blank"
            rel="noreferrer"
          >
            AEPD
          </a>
          )
          <br />
          Cuando sea necesario, solicitaremos el consentimiento explícito y
          separado del usuario antes de recopilar o tratar estos datos.
        </li>
      </PolicyList>

      <PolicyArticleTitle>1.4 Información de la comunidad</PolicyArticleTitle>
      <PolicyText>
        Cuando el usuario utiliza las funciones de comunidad de{" "}
        <strong>pregnancy&amp;baby</strong>, podemos tratar:
      </PolicyText>
      <PolicyHyphenList>
        <li>Nombre de usuario o apodo</li>
        <li>Foto de perfil</li>
        <li>Publicaciones</li>
        <li>Comentarios</li>
        <li>Votaciones y respuestas a votaciones</li>
        <li>Imágenes y otros contenidos publicados voluntariamente</li>
      </PolicyHyphenList>
      <PolicyText>
        La información publicada en las áreas de comunidad puede ser visible
        para otros usuarios. Recomendamos tener especial precaución al publicar
        Datos Personales en espacios accesibles públicamente.
      </PolicyText>

      <PolicyArticleTitle>
        1.5 Información recopilada automáticamente
      </PolicyArticleTitle>
      <PolicyText>
        Al utilizar los Servicios, determinada información técnica y de uso
        puede recopilarse automáticamente, entre ella:
      </PolicyText>
      <PolicyHyphenList>
        <li>Tipo y modelo del dispositivo</li>
        <li>Sistema operativo y versión</li>
        <li>Versión de la aplicación</li>
        <li>Idioma</li>
        <li>Zona horaria</li>
        <li>Dirección IP</li>
        <li>Información sobre el uso y la actividad dentro de la aplicación</li>
        <li>Funciones consultadas o utilizadas</li>
        <li>Frecuencia de uso</li>
        <li>Interacciones con determinadas funciones</li>
        <li>Información de errores y diagnóstico</li>
        <li>
          Token de registro de FCM u otro token necesario para el envío de
          notificaciones push
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Nuestro sitio web también puede utilizar cookies u otras tecnologías
        similares cuando sea necesario.
      </PolicyText>

      <PolicyArticleTitle>1.6 Datos analíticos</PolicyArticleTitle>
      <PolicyText>
        Utilizamos <strong>Google Analytics for Firebase</strong> para
        comprender cómo utilizan los usuarios los Servicios y mejorar las
        funciones y la experiencia de usuario.
      </PolicyText>
      <PolicyText>La información analítica puede incluir:</PolicyText>
      <PolicyHyphenList>
        <li>Información sobre el uso de la aplicación</li>
        <li>Información sobre sesiones</li>
        <li>Uso e interacción con determinadas funciones</li>
        <li>Información sobre el dispositivo y el sistema operativo</li>
        <li>Información técnica y de diagnóstico general</li>
      </PolicyHyphenList>

      <PolicySectionTitle>
        2. Finalidades y bases jurídicas del tratamiento
      </PolicySectionTitle>
      <PolicyText>
        Tratamos los Datos Personales únicamente para finalidades determinadas,
        explícitas y legítimas y sobre una base jurídica adecuada conforme al
        RGPD.
      </PolicyText>
      <PolicyText>
        Dependiendo del tratamiento, las bases jurídicas pueden incluir:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          El <strong>consentimiento</strong> del usuario
        </li>
        <li>
          La <strong>ejecución de un contrato</strong> o la aplicación de
          medidas precontractuales
        </li>
        <li>
          El cumplimiento de una <strong>obligación legal</strong>
        </li>
        <li>
          Nuestros <strong>intereses legítimos</strong>, siempre que no
          prevalezcan los derechos y libertades de los usuarios
        </li>
        <li>
          Para las categorías especiales de datos, una de las circunstancias
          permitidas por el artículo 9 del RGPD, incluida, cuando corresponda,
          la <strong>obtención del consentimiento explícito</strong>
        </li>
      </PolicyHyphenList>
      <PolicyText>Podemos tratar los Datos Personales para:</PolicyText>
      <PolicyHyphenList>
        <li>Crear, autenticar y administrar cuentas</li>
        <li>Proporcionar y operar los Servicios</li>
        <li>
          Predecir la siguiente menstruación, el período fértil y la fecha
          estimada de ovulación
        </li>
        <li>
          Registrar y analizar resultados de pruebas de ovulación y embarazo
        </li>
        <li>
          Gestionar calendarios y recordatorios de tratamientos de fertilidad
        </li>
        <li>Calcular la edad gestacional y la fecha estimada de parto</li>
        <li>Proporcionar contenidos e informes relacionados con el embarazo</li>
        <li>Analizar mediciones de crecimiento fetal</li>
        <li>
          Proporcionar funciones de control del peso durante el embarazo y el
          posparto
        </li>
        <li>Proporcionar informes sobre crecimiento y desarrollo infantil</li>
        <li>
          Proporcionar funciones de gestión de salud, temperatura, medicación,
          vacunación y revisiones médicas del niño
        </li>
        <li>
          Personalizar contenidos y Servicios en función de la información
          proporcionada por el usuario
        </li>
        <li>Enviar recordatorios y notificaciones push</li>
        <li>Responder a consultas y proporcionar atención al cliente</li>
        <li>Garantizar la seguridad e integridad de los Servicios</li>
        <li>Detectar y prevenir usos o accesos no autorizados</li>
        <li>Supervisar el rendimiento y los errores de la aplicación</li>
        <li>Analizar el uso de los Servicios</li>
        <li>Mejorar los Servicios y desarrollar nuevas funciones</li>
        <li>
          Realizar investigaciones y análisis estadísticos utilizando datos
          anonimizados
        </li>
        <li>
          Cumplir obligaciones legales y responder a solicitudes legítimas de
          autoridades competentes
        </li>
      </PolicyHyphenList>
      <PolicyText>
        No vendemos ni alquilamos los Datos Personales de los usuarios.
      </PolicyText>

      <PolicySectionTitle>
        3. Datos de salud y categorías especiales de Datos Personales
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong> ofrece funciones relacionadas con la
        preparación para el embarazo, menstruación, fertilidad, embarazo, salud
        materna y cuidado infantil.
      </PolicyText>
      <PolicyText>
        Por ello, determinados datos tratados a través de los Servicios pueden
        ser considerados <strong>datos relativos a la salud</strong> u otras{" "}
        <strong>categorías especiales de Datos Personales</strong> conforme al
        artículo 9 del RGPD.
      </PolicyText>
      <PolicyText>
        El RGPD establece como regla general la prohibición del tratamiento de
        estas categorías, salvo que concurra alguna de las condiciones previstas
        en el propio artículo 9. Para las funciones de{" "}
        <strong>pregnancy&amp;baby</strong> que requieren el tratamiento de
        datos de salud y cuya base sea el consentimiento, solicitaremos el{" "}
        <strong>consentimiento explícito</strong> del usuario. (
        <a
          href="https://www.aepd.es/areas-de-actuacion/salud/tus-derechos-en-relacion-con-tus-datos-de-salud?utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          AEPD
        </a>
        )
      </PolicyText>
      <PolicyText>
        Estos datos se tratarán únicamente para proporcionar las funciones
        elegidas por el usuario, para las finalidades previamente informadas o
        cuando el tratamiento esté permitido por la legislación aplicable.
      </PolicyText>
      <PolicyText>
        No vendemos datos de salud ni otras categorías especiales de Datos
        Personales.
      </PolicyText>

      <PolicySectionTitle>
        4. Análisis automatizados y servicios personalizados
      </PolicySectionTitle>
      <PolicyText>
        Determinadas funciones de <strong>pregnancy&amp;baby</strong> analizan
        la información facilitada por el usuario para proporcionar resultados
        personalizados.
      </PolicyText>
      <PolicyText>Por ejemplo, podemos utilizar los datos para:</PolicyText>
      <PolicyHyphenList>
        <li>Predecir futuras menstruaciones y períodos fértiles</li>
        <li>Estimar la fecha de ovulación</li>
        <li>Analizar imágenes de pruebas de ovulación o embarazo</li>
        <li>Calcular la evolución del embarazo</li>
        <li>Analizar mediciones de crecimiento fetal</li>
        <li>Analizar la evolución del peso materno</li>
        <li>Analizar el crecimiento y desarrollo infantil</li>
      </PolicyHyphenList>
      <PolicyText>
        Estos análisis tienen una finalidad informativa y de apoyo dentro de los
        Servicios y{" "}
        <strong>
          no sustituyen el diagnóstico, tratamiento o asesoramiento de un
          profesional sanitario
        </strong>
        .
      </PolicyText>
      <PolicyText>
        Salvo que se indique expresamente lo contrario, estos análisis no
        producen decisiones exclusivamente automatizadas con efectos jurídicos o
        efectos significativamente similares sobre el usuario.
      </PolicyText>

      <PolicySectionTitle>
        5. Notificaciones push y comunicaciones
      </PolicySectionTitle>
      <PolicyText>
        Con el consentimiento o de acuerdo con la configuración del usuario,
        podemos enviar notificaciones push relativas a:
      </PolicyText>
      <PolicyHyphenList>
        <li>Recordatorios del Servicio</li>
        <li>Recordatorios de diarios y registros de salud</li>
        <li>Información sobre embarazo o cuidado infantil</li>
        <li>Actualizaciones del Servicio</li>
        <li>
          Eventos, promociones u otra información cuya recepción haya sido
          aceptada separadamente por el usuario
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Para enviar notificaciones push, tratamos un token de registro FCM u
        otro token equivalente.
      </PolicyText>
      <PolicyText>
        Los usuarios pueden modificar sus preferencias de notificaciones en
        cualquier momento desde los Servicios o desde la configuración del
        dispositivo.
      </PolicyText>
      <PolicyText>
        La desactivación de las notificaciones opcionales no impedirá que
        enviemos comunicaciones esenciales relacionadas con el Servicio cuando
        la legislación lo permita.
      </PolicyText>

      <PolicySectionTitle>
        6. Cookies y tecnologías similares
      </PolicySectionTitle>
      <PolicyText>
        Nuestro sitio web puede utilizar cookies y tecnologías similares cuando
        sea necesario para operar los Servicios, recordar configuraciones,
        analizar el uso y mejorar la experiencia del usuario.
      </PolicyText>
      <PolicyText>
        Los usuarios pueden gestionar las cookies mediante la configuración de
        su navegador. La desactivación de determinadas cookies puede afectar al
        funcionamiento de algunas funciones.
      </PolicyText>

      <PolicySectionTitle>
        7. Proveedores de servicios externos
      </PolicySectionTitle>
      <PolicyText>
        Utilizamos proveedores externos para operar, mantener, analizar y
        mejorar los Servicios.
      </PolicyText>
      <PolicyTable>
        <caption className="hide">
          Categoría, Proveedor, Datos o tratamiento, Finalidad
        </caption>
        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Categoría</th>
            <th scope="col">Proveedor</th>
            <th scope="col">Datos o tratamiento</th>
            <th scope="col">Finalidad</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Infraestructura y almacenamiento</td>
            <td>Amazon Web Services (AWS)</td>
            <td className="cell_left">
              Datos Personales tratados a través de los Servicios
            </td>
            <td className="cell_left">Alojamiento y almacenamiento</td>
          </tr>
          <tr>
            <td>Comunicaciones</td>
            <td>NHN Cloud</td>
            <td className="cell_left">Datos de contacto y comunicaciones</td>
            <td className="cell_left">
              Mensajes y comunicaciones del Servicio
            </td>
          </tr>
          <tr>
            <td>Analítica</td>
            <td>Google Analytics for Firebase</td>
            <td className="cell_left">
              Datos de uso y analítica de la aplicación
            </td>
            <td className="cell_left">Análisis y mejora de los Servicios</td>
          </tr>
          <tr>
            <td>Procesamiento de imágenes</td>
            <td>Google Cloud Vision</td>
            <td className="cell_left">
              Imágenes cargadas para funciones de análisis
            </td>
            <td className="cell_left">
              Análisis de imágenes y prestación de funciones
            </td>
          </tr>
          <tr>
            <td>Supervisión de aplicaciones</td>
            <td>Sentry</td>
            <td className="cell_left">
              Registros, errores y datos de diagnóstico
            </td>
            <td className="cell_left">
              Supervisión del rendimiento y seguimiento de errores
            </td>
          </tr>
        </tbody>
      </PolicyTable>
      <PolicyText>
        Estos proveedores solo podrán tratar Datos Personales en la medida
        necesaria para prestar sus servicios y estarán sujetos a las
        obligaciones contractuales y legales aplicables.
      </PolicyText>
      <PolicyText>
        La relación de proveedores puede modificarse conforme evolucionen los
        Servicios.
      </PolicyText>

      <PolicySectionTitle>
        8. Cuándo podemos compartir Datos Personales
      </PolicySectionTitle>
      <PolicyText>
        No vendemos ni alquilamos los Datos Personales de los usuarios.
      </PolicyText>
      <PolicyText>
        Podemos revelar o compartir Datos Personales únicamente en
        circunstancias limitadas, entre ellas:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Con encargados del tratamiento y otros proveedores que actúan por
          cuenta nuestra
        </li>
        <li>Cuando el usuario solicite o autorice la comunicación</li>
        <li>
          Cuando sea necesario para cumplir una obligación legal, una resolución
          judicial o una solicitud válida de una autoridad
        </li>
        <li>
          Cuando sea razonablemente necesario para proteger los derechos, la
          seguridad o la integridad de los usuarios, otros usuarios, Connecti o
          los Servicios
        </li>
        <li>
          En relación con una fusión, adquisición, reestructuración,
          financiación, venta de activos u operación empresarial similar, en los
          términos permitidos por la ley
        </li>
      </PolicyHyphenList>
      <PolicyText>
        También podremos utilizar o compartir información que haya sido{" "}
        <strong>anonimizada de forma irreversible</strong> de manera que ya no
        pueda identificar razonablemente a una persona.
      </PolicyText>

      <PolicySectionTitle>
        9. Datos anonimizados e investigación
      </PolicySectionTitle>
      <PolicyText>
        Podemos anonimizar determinados datos generados durante el uso de los
        Servicios para fines de investigación, estadística, análisis y mejora
        del Servicio.
      </PolicyText>
      <PolicyText>
        Estas investigaciones pueden estar relacionadas con:
      </PolicyText>
      <PolicyHyphenList>
        <li>Salud de la mujer</li>
        <li>Preparación para el embarazo</li>
        <li>Fertilidad</li>
        <li>Embarazo</li>
        <li>Salud materna</li>
        <li>Crecimiento y desarrollo infantil</li>
      </PolicyHyphenList>
      <PolicyText>
        Nuestro proceso de anonimización tiene como finalidad:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Impedir que el usuario pueda ser identificado razonablemente a partir
          de los datos
        </li>
        <li>Eliminar identificadores que vinculen los datos con la cuenta</li>
        <li>
          Impedir que los datos anonimizados vuelvan a vincularse con la cuenta
          o con otros Datos Personales
        </li>
        <li>
          Impedir que podamos volver a identificar al usuario a partir de dichos
          datos
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Cuando los datos hayan sido{" "}
        <strong>anonimizados de forma efectiva e irreversible</strong> de modo
        que una persona ya no sea identificable, dejarán de considerarse Datos
        Personales en la medida prevista por la legislación aplicable.
      </PolicyText>
      <PolicyText>
        <strong>
          Los datos anonimizados podrán conservarse indefinidamente
        </strong>{" "}
        para fines de investigación, estadística, análisis y mejora de los
        Servicios.
      </PolicyText>
      <PolicyText>
        Podremos utilizar o compartir datos anonimizados, datos agregados o
        resultados de investigación con instituciones de investigación u otros
        socios siempre que ninguna persona pueda ser identificada
        razonablemente.
      </PolicyText>

      <PolicySectionTitle>
        10. Conservación de datos y eliminación de la cuenta
      </PolicySectionTitle>
      <PolicyText>
        Conservamos los Datos Personales identificables únicamente durante el
        tiempo razonablemente necesario para proporcionar los Servicios, cumplir
        las finalidades descritas en esta Política o cumplir obligaciones
        legales.
      </PolicyText>
      <PolicyList>
        <li>
          <strong>Eliminación de la cuenta</strong>
          <br />
          Los usuarios pueden eliminar su cuenta mediante la función
          correspondiente de los Servicios o solicitándolo a la Empresa.
          <br />
          Cuando se elimina una cuenta:
          <PolicyHyphenList>
            <li>La cuenta será cancelada.</li>
            <li>
              Los Datos Personales que permitan identificar al usuario serán
              eliminados o destruidos de conformidad con la legislación
              aplicable.
            </li>
            <li>
              Si el usuario crea posteriormente una nueva cuenta, los Datos
              Personales de la cuenta anterior no serán restaurados ni
              reutilizados.
            </li>
          </PolicyHyphenList>
          Determinada información podrá conservarse cuando sea necesario o esté
          permitido por la ley, por ejemplo, para cumplir obligaciones legales,
          resolver controversias, prevenir fraude o abuso o ejercer derechos
          contractuales.
          <br />
          Tal como se explica en la sección 9, algunos datos derivados del uso
          del Servicio podrán ser{" "}
          <strong>
            anonimizados irreversiblemente antes o durante la eliminación de la
            cuenta
          </strong>{" "}
          y conservarse indefinidamente para investigación, estadística,
          análisis y mejora del Servicio. Dichos datos no podrán volver a
          asociarse al usuario.
        </li>
        <li>
          <strong>Eliminación de la aplicación</strong>
          <br />
          Desinstalar <strong>pregnancy&amp;baby</strong> del dispositivo no
          elimina automáticamente la cuenta ni los Datos Personales.
          <br />
          Para solicitar su eliminación, el usuario debe eliminar su cuenta a
          través del Servicio o ponerse en contacto con nosotros.
        </li>
      </PolicyList>

      <PolicySectionTitle>11. Derechos de los usuarios</PolicySectionTitle>
      <PolicyText>
        De conformidad con el RGPD y la normativa española aplicable, los
        usuarios pueden ejercer, cuando corresponda, los siguientes derechos:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          <strong>Derecho de acceso</strong> a sus Datos Personales
        </li>
        <li>
          <strong>Derecho de rectificación</strong> de datos inexactos o
          incompletos
        </li>
        <li>
          <strong>Derecho de supresión</strong> (“derecho al olvido”)
        </li>
        <li>
          <strong>Derecho a la limitación del tratamiento</strong>
        </li>
        <li>
          <strong>Derecho de oposición</strong>
        </li>
        <li>
          <strong>Derecho a la portabilidad de los datos</strong>
        </li>
        <li>
          <strong>Derecho a retirar el consentimiento</strong> en cualquier
          momento cuando el tratamiento se base en el consentimiento
        </li>
        <li>
          Derecho a no ser objeto, cuando proceda, de decisiones basadas
          únicamente en tratamientos automatizados con efectos jurídicos o
          similares significativos
        </li>
        <li>
          Derecho a presentar una reclamación ante una autoridad de control
        </li>
      </PolicyHyphenList>
      <PolicyText>
        La retirada del consentimiento no afectará a la licitud del tratamiento
        realizado antes de dicha retirada.
      </PolicyText>
      <PolicyText>
        Algunos derechos pueden estar sujetos a limitaciones o excepciones
        establecidas por la legislación.
      </PolicyText>
      <PolicyText>
        Para ejercer estos derechos, puede ponerse en contacto con:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
      <PolicyText>
        Podremos solicitar la información razonablemente necesaria para
        verificar la identidad de la persona solicitante.
      </PolicyText>
      <PolicyText>
        Responderemos dentro de los plazos establecidos por la legislación
        aplicable.
      </PolicyText>
      <PolicyText>
        Los usuarios en España también tienen derecho a presentar una
        reclamación ante la{" "}
        <strong>Agencia Española de Protección de Datos (AEPD)</strong> si
        consideran que el tratamiento de sus Datos Personales infringe la
        normativa aplicable.
      </PolicyText>

      <PolicySectionTitle>
        12. Seguridad de los Datos Personales
      </PolicySectionTitle>
      <PolicyText>
        Aplicamos medidas técnicas y organizativas razonables destinadas a
        proteger los Datos Personales frente a:
      </PolicyText>
      <PolicyHyphenList>
        <li>Acceso no autorizado</li>
        <li>Pérdida</li>
        <li>Robo</li>
        <li>Uso indebido</li>
        <li>Divulgación no autorizada</li>
        <li>Alteración</li>
        <li>Destrucción</li>
      </PolicyHyphenList>
      <PolicyText>
        Estas medidas pueden incluir cifrado durante la transmisión y el
        almacenamiento cuando corresponda, controles de acceso, supervisión de
        sistemas, gestión de vulnerabilidades, procedimientos internos de
        seguridad y restricciones de acceso.
      </PolicyText>
      <PolicyText>
        El acceso a los Datos Personales se limita al personal que lo necesita
        para desempeñar sus funciones.
      </PolicyText>
      <PolicyText>
        No obstante, ningún método de transmisión o almacenamiento electrónico
        puede garantizar una seguridad absoluta.
      </PolicyText>
      <PolicyText>
        En caso de producirse una violación de seguridad de los Datos
        Personales, adoptaremos las medidas correspondientes y notificaremos a
        los usuarios afectados y/o a las autoridades de control cuando así lo
        exija la legislación.
      </PolicyText>

      <PolicySectionTitle>
        13. Lugar de almacenamiento y transferencias internacionales
      </PolicySectionTitle>
      <PolicyText>
        Connecti Co., Ltd. está establecida en la{" "}
        <strong>República de Corea</strong>.
      </PolicyText>
      <PolicyText>
        La infraestructura principal de la aplicación y el almacenamiento de
        Datos Personales se alojan mediante{" "}
        <strong>
          Amazon Web Services (AWS), región Asia-Pacífico (Seúl), República de
          Corea.
        </strong>
      </PolicyText>
      <PolicyText>
        Por tanto, los Datos Personales de usuarios residentes en España pueden
        ser transferidos y almacenados en la República de Corea.
      </PolicyText>
      <PolicyText>
        Además, debido a que <strong>pregnancy&amp;baby</strong> utiliza
        proveedores globales, ciertos Datos Personales o información técnica
        pueden ser tratados por, o estar accesibles para, proveedores ubicados
        fuera del Espacio Económico Europeo (EEE).
      </PolicyText>
      <PolicyText>Entre dichos proveedores pueden encontrarse:</PolicyText>
      <PolicyHyphenList>
        <li>Amazon Web Services</li>
        <li>Google</li>
        <li>NHN Cloud</li>
        <li>Sentry</li>
      </PolicyHyphenList>
      <PolicyText>
        Las transferencias internacionales de Datos Personales se realizarán de
        conformidad con el <strong>capítulo V del RGPD</strong>.
      </PolicyText>
      <PolicyText>
        Cuando exista una decisión de adecuación de la Comisión Europea
        aplicable al país o destinatario, podremos basarnos en dicha decisión.
        En ausencia de una decisión de adecuación aplicable, utilizaremos
        garantías adecuadas reconocidas por el RGPD, como cláusulas
        contractuales tipo u otros mecanismos legalmente permitidos, o,
        excepcionalmente, alguna de las excepciones previstas por el RGPD. La
        AEPD señala que las transferencias a terceros países pueden basarse en
        una decisión de adecuación o, en su defecto, en garantías adecuadas
        conforme al artículo 46 del RGPD. (
        <a
          href="https://www.aepd.es/areas-de-actuacion/salud/tus-derechos-en-relacion-con-tus-datos-de-salud?utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          AEPD
        </a>
        )
      </PolicyText>
      <PolicyText>
        Cuando la legislación exija información adicional sobre una
        transferencia internacional, facilitaremos dicha información al usuario.
      </PolicyText>

      <PolicySectionTitle>14. Privacidad de menores</PolicySectionTitle>
      <PolicyText>
        Para los usuarios en España, el tratamiento de Datos Personales basado
        en el consentimiento de un menor puede fundarse en su propio
        consentimiento cuando <strong>sea mayor de 14 años</strong>.
      </PolicyText>
      <PolicyText>
        Cuando el usuario tenga <strong>menos de 14 años</strong>, el
        tratamiento basado en el consentimiento solo será lícito cuando se haya
        obtenido el consentimiento del titular de la patria potestad o tutela,
        salvo que otra normativa aplicable establezca requisitos adicionales
        para el acto o servicio concreto. Esta regla se establece en el artículo
        7 de la Ley Orgánica 3/2018. (
        <a
          href="https://www.boe.es/buscar/act.php?id=BOE-A-2018-16673&lang=es&p=&tn=1&utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          BOE
        </a>
        )
      </PolicyText>
      <PolicyText>
        Por tanto, una persona que no pueda prestar válidamente su
        consentimiento y que no cuente con el consentimiento parental o del
        representante legal exigido no deberá crear ni utilizar una cuenta de{" "}
        <strong>pregnancy&amp;baby</strong>.
      </PolicyText>
      <PolicyText>
        No recopilamos deliberadamente Datos Personales de personas que no
        puedan prestar un consentimiento válido y que no cuenten con la
        autorización necesaria.
      </PolicyText>
      <PolicyText>
        Si considera que se nos han facilitado Datos Personales de un menor de
        manera contraria a la legislación aplicable, póngase en contacto con{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
        . Adoptaremos las medidas correspondientes, incluida la eliminación de
        la información cuando proceda.
      </PolicyText>

      <PolicySectionTitle>
        15. Información de niños introducida por los usuarios
      </PolicySectionTitle>
      <PolicyText>
        Algunas funciones de cuidado infantil permiten que el padre, la madre,
        el tutor o una persona legalmente autorizada introduzca información
        relativa a un niño.
      </PolicyText>
      <PolicyText>Esta información puede incluir:</PolicyText>
      <PolicyHyphenList>
        <li>Nombre</li>
        <li>Sexo</li>
        <li>Fecha de nacimiento</li>
        <li>Mediciones corporales al nacer</li>
        <li>Datos de crecimiento</li>
        <li>Datos de desarrollo</li>
        <li>Registros de revisiones médicas</li>
        <li>Registros de vacunación</li>
        <li>Temperatura corporal</li>
        <li>Medicación</li>
        <li>Información sobre enfermedades</li>
        <li>Fotografías relacionadas</li>
      </PolicyHyphenList>
      <PolicyText>
        Al introducir Datos Personales de un niño en los Servicios, el usuario
        declara que está autorizado para facilitar y gestionar dicha información
        como progenitor, tutor, representante legal u otra persona legalmente
        autorizada.
      </PolicyText>
      <PolicyText>
        Solo trataremos estos datos para las finalidades descritas en esta
        Política y en la medida permitida por la legislación aplicable.
      </PolicyText>

      <PolicySectionTitle>
        16. Servicios de inicio de sesión y servicios externos
      </PolicySectionTitle>
      <PolicyText>
        Cuando el usuario accede a <strong>pregnancy&amp;baby</strong> mediante
        Google, Apple, el uso de dichos servicios también está sujeto a los
        términos y políticas de privacidad del proveedor correspondiente.
      </PolicyText>
      <PolicyText>
        Los Servicios también pueden incluir enlaces a sitios web, aplicaciones
        o servicios gestionados por terceros.
      </PolicyText>
      <PolicyText>
        No somos responsables de las prácticas independientes de privacidad de
        dichos terceros. Recomendamos revisar sus políticas de privacidad antes
        de facilitarles Datos Personales.
      </PolicyText>

      <PolicySectionTitle>17. No vendemos Datos Personales</PolicySectionTitle>
      <PolicyText>
        No vendemos ni alquilamos los Datos Personales de nuestros usuarios.
      </PolicyText>
      <PolicyText>
        Tampoco vendemos Datos Personales relacionados con:
      </PolicyText>
      <PolicyHyphenList>
        <li>Salud</li>
        <li>Preparación para el embarazo</li>
        <li>Fertilidad</li>
        <li>Embarazo</li>
        <li>Niños</li>
      </PolicyHyphenList>

      <PolicySectionTitle>
        18. Modificaciones de esta Política de Privacidad
      </PolicySectionTitle>
      <PolicyText>Podremos modificar esta Política para reflejar:</PolicyText>
      <PolicyHyphenList>
        <li>Cambios en los Servicios</li>
        <li>Cambios en nuestras actividades de tratamiento</li>
        <li>Cambios en los proveedores de servicios</li>
        <li>Cambios en las leyes o normativas aplicables</li>
      </PolicyHyphenList>
      <PolicyText>
        Si una modificación afecta de manera significativa a los derechos del
        usuario o a la forma en que tratamos sus Datos Personales,
        proporcionaremos la información correspondiente antes de que el cambio
        entre en vigor cuando así lo exija la legislación.
      </PolicyText>
      <PolicyText>
        Cuando sea necesario, solicitaremos nuevamente el consentimiento del
        usuario.
      </PolicyText>
      <PolicyText>
        La fecha de entrada en vigor y la fecha de la última actualización
        aparecerán al inicio de esta Política.
      </PolicyText>

      <PolicySectionTitle>
        19. Contacto sobre protección de datos
      </PolicySectionTitle>
      <PolicyText>
        Para realizar consultas sobre esta Política de Privacidad, el
        tratamiento de Datos Personales o el ejercicio de sus derechos, puede
        ponerse en contacto con:
      </PolicyText>
      <PolicyText>
        <strong>Connecti Co., Ltd.</strong>
        <br />
        B2F, Unit 56
        <br />
        176 Yanghwa-ro, Mapo-gu
        <br />
        Seoul, Republic of Korea
        <br />
        <strong>Correo electrónico:</strong>{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>

      <PolicySectionTitle>
        20. Disposiciones aplicables a los usuarios en España
      </PolicySectionTitle>
      <PolicyText>
        Los Datos Personales de usuarios en España serán tratados de conformidad
        con el{" "}
        <strong>
          Reglamento (UE) 2016/679, Reglamento General de Protección de Datos
          (RGPD), la Ley Orgánica 3/2018, de Protección de Datos Personales y
          garantía de los derechos digitales (LOPDGDD)
        </strong>{" "}
        y demás normativa aplicable.
      </PolicyText>
      <PolicyText>
        Los <strong>datos relativos a la salud</strong> son categorías
        especiales de Datos Personales y están sujetos a una protección
        reforzada. Cuando el tratamiento de dichos datos se base en el
        consentimiento, solicitaremos el{" "}
        <strong>consentimiento explícito</strong> del usuario. (AEPD)
      </PolicyText>
      <PolicyText>
        Los usuarios en España podrán ejercer los derechos reconocidos por el
        RGPD, incluidos acceso, rectificación, supresión, limitación, oposición,
        portabilidad y retirada del consentimiento, cuando resulten aplicables.
      </PolicyText>
      <PolicyText>
        También podrán presentar una reclamación ante la{" "}
        <strong>Agencia Española de Protección de Datos (AEPD)</strong>.
      </PolicyText>
      <PolicyText>
        Los Datos Personales de los usuarios españoles pueden ser transferidos a
        la República de Corea, donde se encuentra la infraestructura principal
        de <strong>pregnancy&amp;baby</strong>, así como ser tratados por
        determinados proveedores globales. Estas transferencias se realizarán
        conforme a las garantías y mecanismos exigidos por el capítulo V del
        RGPD. (
        <a
          href="https://www.aepd.es/derechos-y-deberes/cumple-tus-deberes/medidas-de-cumplimiento/garantias-transferencias-datos-personales?utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          AEPD
        </a>
        )
      </PolicyText>
      <PolicyText>
        En España, cuando el tratamiento se base en el consentimiento del menor,
        este puede prestarlo por sí mismo a partir de los{" "}
        <strong>14 años</strong>, con las excepciones previstas legalmente. Para
        los menores de 14 años será necesario el consentimiento del titular de
        la patria potestad o tutela. (
        <a
          href="https://www.boe.es/buscar/act.php?id=BOE-A-2018-16673&lang=es&p=&tn=1&utm_source=chatgpt.com"
          target="_blank"
          rel="noreferrer"
        >
          BOE
        </a>
        )
      </PolicyText>
      <PolicyText>
        Para ejercer sus derechos o realizar cualquier consulta relacionada con
        el tratamiento de sus Datos Personales:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
    </PolicyContainer>
  );
};

export default PrivacyEs;
